// Design tokens and constants for PreviewHeroHeader
// Following "No Magic Strings" or "Magic Numbers" rule

export const HERO_HEADER_VARIANTS = {
  BUSINESS: "business",
  VCARD: "vcard",
  WEBSITE: "website",
  APPS: "apps",
  LINKS: "links",
} as const;

export type HeroHeaderVariant = (typeof HERO_HEADER_VARIANTS)[keyof typeof HERO_HEADER_VARIANTS];

export const LOGO_VARIANTS = {
  HERO: "hero",
  LOGO_LARGE: "logo-large",
} as const;

export const CLOUDINARY_TRANSFORMATIONS = {
  WEBSITE: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
  APPS: ["w_400,h_400,q_90,f_auto,c_fill"],
  LINKS: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
} as const;

export const ICON_PATHS = {
  IMAGE_PLACEHOLDER: "/svg/icon-image.svg",
} as const;

// Design System Spacing Tokens
export const SPACING = {
  SMALL: "u-spacing-2",
  MEDIUM: "u-spacing-4",
  LARGE: "u-spacing-5",
} as const;

// Typography Tokens
export const TYPOGRAPHY_CLASSES = {
  SEMIBOLD: "u-semibold",
  BOLD: "u-bold",
} as const;
